import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";

const getResponse = (userCredential) => {
    const { expiresIn } = userCredential._tokenResponse
    const { accessToken, uid, email } = userCredential.user
    return { accessToken, uid, email, expiresIn }
}

export const authAPI = {
    async signUp(mail, password) {
        try {
            const auth = getAuth()
            const userCredential = await createUserWithEmailAndPassword(auth, mail, password)
            return getResponse(userCredential)
        } catch (e) {
            throw e
        }
    },
    async logIn(mail, password) {
        try {
            const auth = getAuth();
            const userCredential = await signInWithEmailAndPassword(auth, mail, password)
            return getResponse(userCredential)
        } catch (e) {
            throw e
        }
    },
    async logOut() {
        try {
            const auth = getAuth();
            await signOut(auth)
        } catch (e) {
            throw e
        }
    }
}


